import { apiRequest} from './index'

export const createBrokerRequest = (brokers) => {
  return apiRequest(
    `/admin/brokers`,
    {
      method: 'POST',
      body: JSON.stringify(brokers)
    },
    true
  )
}
export const getBrokersRequest = (filters) => {
  const {
    page=0,
    limit=0,
    search=''
  } = filters;

  return apiRequest(
    `/admin/brokers?page=${page}&limit=${limit}&search=${search}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getBrokerRequest = (id) => {
  return apiRequest(
    `/admin/brokers/${id}`,
    {
      method: 'GET'
    },
    true
  )
}

export const updateBrokerRequest = (brokers) => {
  return apiRequest(
    `/admin/brokers/${brokers._id}`,
    {
			method: 'PUT',
			body: JSON.stringify(brokers)
    },
    true
  )
}

export const deleteBrokerRequest = (id) => {
  return apiRequest(
    `/admin/brokers/${id}`,
    {
			method: 'DELETE'
    },
    true
  )
}